export default {
    
    find:       { method: 'get',    url: 'hour_group_dates' },
    create:     { method: 'post',   url: 'hour_group_dates'},
    update:     { method: 'put',    url: 'hour_group_dates/{id}'},
    delete:     { method: 'delete', url: 'hour_group_dates/{id}'},
    findToken:  { method: 'get',    url: 'hour_group_dates/token/{token}'},
}